import { NormalizeTelephone } from "../Validations/InputMasks";

export function formatedTelefone(tel: string) {
    tel = tel.replace(/\D/g, "");

    if (tel !== "" && tel.charAt(0) === "0") {
        tel = tel.substring(1);
    } // removendo o 0 que algumas pessoas colocam antes do DDD

    if (tel.length > 11) return NormalizeTelephone(tel);
    else if (tel.length > 9)
        return `(${tel.substring(0, 2)}) ${tel.substring(2)}`;
    else if (tel.length >= 8) {
        const [, number1, number2] = tel.split(/(\d{4,5})(\d{4})/);
        return `${number1}-${number2}`;
    } else return tel;
}

export function telefoneFormatadoSem9(tel: string) {
    tel = tel.replace(/\D/g, "");
    if (tel.length > 10) {
        var splitTel = tel.split("");
        var reverseSplit = splitTel.reverse();
        reverseSplit.splice(8, 1);
        var numberSem9 = reverseSplit.reverse().join("");
        return numberSem9;
    } else return tel;
}

export function formatPhoneNumber(value: string) {
    // Remove tudo que não for dígito
    const phoneNumber = value.replace(/\D/g, "");

    // Formata conforme o tamanho do número
    if (phoneNumber.length <= 10) {
        // Formato para telefones fixos: (XX) XXXX-XXXX
        return phoneNumber.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    } else {
        // Formato para celulares: (XX) XXXXX-XXXX
        return phoneNumber.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
    }
}

export function FormatedTelefoneComplete(v: string) {
    v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
    v = v.replace(/(\d)(\d{4})$/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos
    return v;
}
export function formatPhoneTelefonia(COD_DDD: string, NR_TELEFONE: string) {
    const phonestring = COD_DDD + NR_TELEFONE;
    const formated = phonestring.replace(/\D/g, "");
    return formated;
}
// usado para formatar o telefone que vem do firebase
export function formatPhone(telString: string) {
    try {
        return telString.split(":")[1]; // [0]"whatsapp" : [1]"+553131810970"
    } catch (err) {
        return "";
    }
}
export function fullFormatPhone(telString: string) {
    if (telString.length < 0) return "";
    const preFormat = formatPhone(telString);
    if (!preFormat) return "";
    const insert9 = preFormat.length === 13;
    let str = `${preFormat.substr(0, 3)} (${preFormat.substr(3, 2)})`;
    str += insert9
        ? ` 9 ${preFormat.substr(5, 4)}-${preFormat.substr(9, 4)}`
        : ` ${preFormat.substr(5, 1)} ${preFormat.substr(
              6,
              4
          )}-${preFormat.substr(10, 4)}`;
    return str;
}

export function FormatarNumeroTelefone(numeroCompleto?: string) {
    //função para formatar o numero de telefone para o formato: (DDD) 12345-6789
    const textoSeparado = numeroCompleto?.split(")");

    const primeiraParte = textoSeparado?.[1].slice(0, -4);
    const segundaParte = textoSeparado?.[1].slice(-4);

    return `${textoSeparado?.[0]}) ${primeiraParte}-${segundaParte}`;
}

export function formatMoneyReais(valor: number) {
    if (isNaN(valor)) valor = 0;
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    }).format(valor);
}
export function formatPercentual(valor: number) {
    if (isNaN(valor)) valor = 0;
    const [inteiro, decimal] = valor.toFixed(2).split(".");
    return `${inteiro},${decimal}%`;
}

export function formatMessageTimeStamp(
    TimeStamp: number,
    sempreMostraHorario?: boolean,
    TimeStampSync?: boolean
) {
    const messageDate = new Date(TimeStamp);
    // Aparentemente não é mais necessário offset:
    //messageDate.setMinutes( messageDate.getMinutes() + messageDate.getTimezoneOffset() )  //Offset por causa do fuso horario
    return formatMessageDate(messageDate, sempreMostraHorario);
}
export function formatMessageDateString(
    dateString: string,
    sempreMostraHorario?: boolean
) {
    const messageDate = new Date(dateString);

    return formatMessageDate(messageDate, sempreMostraHorario);
}
export function formatMessageDate(
    messageDate: Date,
    sempreMostraHorario?: boolean
) {
    const nowDate = new Date();
    const yesterndayDate = new Date(new Date().setDate(nowDate.getDate() - 1));

    if (nowDate.toDateString() === messageDate.toDateString()) {
        return messageDate.toLocaleTimeString().substring(0, 5);
    } else if (yesterndayDate.toDateString() === messageDate.toDateString()) {
        return `Ontem${
            sempreMostraHorario
                ? ` - ${messageDate.toLocaleTimeString().substring(0, 5)}`
                : ""
        }`;
    } else {
        return `${messageDate.toLocaleDateString()}${
            sempreMostraHorario
                ? ` - ${messageDate.toLocaleTimeString().substring(0, 5)}`
                : ""
        }`;
    }
}

export function formatTimeDiff(TimeStampDiff: number) {
    const seconds = TimeStampDiff / 1000;
    if (seconds >= 86400) {
        // dias
        return `+${Math.floor(seconds / 86400)} dia${
            seconds > 86400 * 2 ? "s" : ""
        }`;
    } else if (seconds > 3600) {
        // horas
        return `${Math.floor(seconds / 3600)}h${Math.floor(
            (seconds % 3600) / 60
        )}min`;
    } else {
        return `${Math.floor(seconds / 60)}:${
            Math.floor(seconds % 60) < 10 ? "0" : ""
        }${Math.floor(seconds % 60)}`;
    }
}

export function detectarTagsHtml(str: string) {
    return str?.match(/<\/?[a-z][\s\S]*>/i);
}
export function retirarTagsHtml(str: string) {
    const stringWithStylesTagsRemoved = str?.replaceAll(
        /<style>[\d,\D]+<\/style>/g,
        ""
    );
    return stringWithStylesTagsRemoved?.replaceAll(/<.+?>|&\S+?;/g, "");
}

// set de input
export const valueAsNumberOr0 = (input: any) =>
    isNaN(Number(input)) ? 0 : Number(input);
